const handleSearch = () => {

  let searchInput = document.querySelector('.search-input')
  let searchICon = document.querySelector('.menu__link.search-icon')
  let searchButton = document.querySelector('.search-button.search-icon')
  let searchForm = document.querySelector('.search-form')
  searchButton.addEventListener('click', function(e) {
      e.preventDefault()
      let inputClass = searchInput.classList

      
      if (inputClass.contains('search_open')) {
		  
          let keys = searchInput.value;
          if(keys.length > 0){
              searchForm.submit();
              searchForm.reset();
          } else{
              searchInput.focus()
              return false;
          }
      } else{
          searchInput.focus()
          searchInput.classList.add('search_open')	
          return false;
      }
      searchForm.reset()
  })
  let body = document.querySelector('body')
  body.addEventListener('click', (event) => {

      let arr = [searchICon, searchButton]
      if (!arr.includes(event.target)) {
          let inputClass = searchInput.classList
          inputClass.remove('search_open')
      }


  })
}

const onSelected = () => {
  window.addEventListener('DOMContentLoaded', (event) => {
    const selected = document.querySelector('.swatch__item--active')
    if(selected) {
        const valueDiv = document.querySelector('.show-value')
        const selectedInput = selected.querySelector('.swatch__input')
        if(selectedInput) {
            valueDiv.innerHTML = `<span>${selectedInput.value}</span>`
        }
    }
  })
}



const showColorName = () => {
  const colors = document.querySelector('.swatch__colors')
  if(colors) {
    colors.addEventListener('click', function(e) {
      const self = e.target
      const valueDiv = document.querySelector('.show-value')
      if(self.classList.contains('swatch__item') || self.classList.contains('select-img')) {
        const input = self.querySelector('.swatch__input')
        const val = input.value
        valueDiv.innerHTML = `<span>${val}</span>`
      }
    })
  }
}



// const toggleSizingChart = () => {
// //   const silderImg = document.querySelector('.product__slideshow-nav-image:nth-child(3)')
//   const silderImg = document.querySelector('[alt~=Sizing]')
//   console.log('silderImg', silderImg)
//   if (!silderImg) {
//     document.addEventListener('DOMContentLoaded', function() {
//     	document.querySelector('.product__size-chart').classList.add('d-none')
//     })

//   }
// }

const getImgIndex = function () {

    let imgs = document.querySelectorAll('.product__slideshow-nav-image')
    for (let index = 0; index < imgs.length; index++) {
        const element = imgs[index]
        let alt = element.alt
        if(alt.toUpperCase() === 'SIZING CHART') {
            return element.dataset.slideIndex
        }
    }
    // 循环完没有找到设置 sizing chart 就隐藏尺寸链接
    document.querySelector('.product__size-chart').classList.add('d-none')
    return null
}



const getSizingChart = function(imgIndex) {
  	console.log('imgIndex', imgIndex)
    let slideContainer = document.querySelectorAll('.product__slideshow-slide')
    for (let i = 0; i < slideContainer.length; i++) {
        const element = slideContainer[i]
        let slickIndex = element.dataset.slickIndex
        console.log('slickIndex', slickIndex)
        if(slickIndex === imgIndex) {
            const img = element.querySelector('.aspect-ratio .product__slideshow-image')
            return img
        }
    }
  
    return null
}
  
const setSizingChart = function () {
    const imgIndex = getImgIndex()
    const sizingChart = getSizingChart(imgIndex)
    const modalBody = document.querySelector('.size-chart-modal .modal__body.rte')
    console.log('sizingChart', sizingChart)
    if(sizingChart) {
      modalBody.innerHTML = ''
      modalBody.insertAdjacentElement('beforeend', sizingChart)
    }
    
}


const onPerPageSelect = function() {
  /* Grab the <select> element, and cache it should it be needed later */


  /* Bind a change event to the dropdown */
  $('#paginateBy').on('change', function(){

    /* Get the current value. Some value validation could be added here (but we don't) */
    const val = $(this).val();
	console.log('val', val)
    /* Send the value as a cart attribute via the AJAX API */
    $.ajax({
      type: "POST",
      url: '/cart.js',
      data: {"attributes[pagination]": val}, /* We are using an attribute named "pagination" */
      success: function(d){
        /* 
          On sucess, reload the page.  
          Warning: If you have scripts on the page that auto trigger the change even the page may reload forever.
          If you do, be sure to add code to account for that.
          */
        window.location.reload(); 
      },
      dataType: 'json'
    });
  });



}


const insertPerPageSelect = function() {

	const select = document.querySelector('.header__push-filter--perpage')
    const sortSelect = document.querySelector('.header__push-filter--sort')
	const selectContainer = document.querySelector('.header__push-content')
    console.log('select', select)
    if (selectContainer && select) {
    	selectContainer.insertBefore(select, sortSelect)
    
    }
    
}



const __scriptMain = () => {
  
  // 搜索框
  handleSearch()
  
  // 显示 Sizing Chart 的链接
//   toggleSizingChart()
  
  // 页面初始化时显示颜色名
  onSelected()
  
  // 将选择的颜色名显示出来
  showColorName()
  // 设置尺寸图
//   setSizingChart()
  
  onPerPageSelect()
  
  insertPerPageSelect()
}
__scriptMain()